<template>
    <div class="page_offices">


        <div class="office_content container-1200">
            <div class="part1">
                <div class="part1_title"><img :src="require('@/assets/images/office/office_title.png')" alt="">Contrimetric
                    Headquarter</div>

                <div class="part1_content">
                    <div class="part1_content_title">Singapore</div>
                    <div>8 Eu Tong Sen Street,#16-81,The Central,Singapore 059818</div>
                    <div class="part1_content_time">
                        <div>Office Hours: 8:30-17:30</div>
                        <div class="pb">Pubilc Holidays</div>
                    </div>
                </div>
            </div>

            <div class="part1 part_width" style="border-left: 1px solid #e9e9e9;padding-left: 10px;">
                <div class="part1_title"><img :src="require('@/assets/images/office/office_title.png')" alt="">China</div>

                <div class="part1_content">
                    <div class="part1_content_title">Shenzhen</div>
                    <div>1515A, Block A, Zhongguan Times Square, No.4168, Liuxian Avenue, Pingshan Community,
                        Taoyuan Street, Nanshan District, Shenzhen</div>
                    <div class="part1_content_time">
                        <div>Office Hours: 8:30-17:30</div>
                        <div class="pb">Pubilc Holidays</div>
                    </div>
                </div>

                <div class="part1_content">
                    <div class="part1_content_title">Zhengzhou</div>
                    <div>1628, 16th Floor, Block B, Jianye Triumph Plaza, No.122，Huayuan Avenue, Jinshui District,
                        Zhengzhou</div>
                    <div class="part1_content_time">
                        <div>Office Hours: 8:30-17:30</div>
                        <div class="pb">Pubilc Holidays</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style lang='scss'>
.navContent {
    min-height: unset !important;
}

.page_offices {
    background-color: #F6FAFC;
    padding: 71.5px 0;

    .office_content {
        display: flex;

        .part1 {
            width: 30%;

        }

        .part_width {
            flex: 1;
        }
    }

    .part1 {
        margin: 30px 0;

        .part1_title {
            font-size: 24px;
            font-weight: bold;
            display: flex;
            align-items: center;

            img {
                margin-right: 4px;
            }
        }

        .part1_content {
            padding: 10px;
            margin: 10px 0;
            width: 46%;
            display: inline-block;
            line-height: 20px;

            .part1_content_title {
                margin: 10px 0;
                font-size: 18px;
            }

            .part1_content_time {
                margin-top: 10px;

                .pb {
                    font-weight: bold;
                }
            }
        }
    }
}</style>